import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Iframe from "@components/CustomTypography/Iframe/Iframe"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import getValueOrThrow from "@helpers/getValueOrError"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import styles from "./PrivacyPolicy.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const PrivacyPolicy = (props: Props) => {
	const mainContent = getValueOrThrow(props.data.mainContent)
	return (
		<>
			<div id={"top"} />
			<FullWidthHeader
				data={{
					title: props.data.sectionTitle,
				}}
				position={"left"}
				size={"L"}
			/>
			<ContainerWrapper>
				<Separator size={128}>
					<div
						className={styles.contentContainer}
						id={"privacy_statement"}
					>
						<Typography
							variant={Variant.Description}
							content={mainContent[0].title}
						/>
						<Separator size={16}>
							{mainContent[0].preview && (
								<Iframe {...mainContent[0].preview} />
							)}
						</Separator>
						<Typography
							variant={Variant.Description}
							content={mainContent[0].subtitle}
						/>
					</div>
					<Separator />
					<div className={`${styles.tables}`}>
						<Typography
							variant={Variant.Description}
							content={mainContent[1].content}
						/>
					</div>
				</Separator>
			</ContainerWrapper>
		</>
	)
}

export default PrivacyPolicy
